<template>
  <el-dialog
    :title="dialogTitle"
    body-type="tip"
    width="400px"
    footer-padding="0 30px 15px"
    :visible="visible"
    class="unbind-shop-box"
    :before-close="close"
  >
    <p class="info-box">确定解除与 {{ currentSelect.assetName }} 的绑定关系吗？</p>
    <p class="info-box mb15">从工作台解绑后，分配的员工账号也将同时解绑，为防止误操作请当前操作人进行手机验证：</p>
    <div class="search-from">
      <label class="from-label">解绑验证码：</label>
      <el-input v-model.trim="code" class="from-input w180" :placeholder="codePlaceholder"></el-input>
      <el-popover
        v-model="surePhoneTip"
        placement="bottom-end"
        width="170"
        class="popover-wrapper"
      >
        <p v-if="phone" style="margin: 0;">即将向{{ phone }}发送验证码</p>
        <p v-else style="margin: 0;">暂无手机号，<span style="color: #4d80f0;cursor: pointer;" :clstag="`pageclick|keycount|${pageClstag}|${otherClstag}unbind_sendMsg_addPhone`" @click="goAddPhone">去添加</span></p>
        <div class="button-wrapper" style="text-align: right;">
          <el-button v-if="phone" type="text" size="small" style="color: #4D80F0;" :clstag="`pageclick|keycount|${pageClstag}|${otherClstag}unbind_sendMsg_sure`" @click="sendMsgCode">确定</el-button>
          <el-button size="small" type="text" style="color: #000000" :clstag="`pageclick|keycount|${pageClstag}|${otherClstag}unbind_sendMsg_cancel`" @click="surePhoneTip = false">取消</el-button>
        </div>
        <el-button
          slot="reference"
          functional
          class="send-code-btn"
          :disabled="sendMsgDisable || loading"
          :clstag="`pageclick|keycount|${pageClstag}|${otherClstag}unbind_sendMsg`"
        >
          <span v-if="sendMsgCount < 1">获取验证码</span>
          <span v-else>重新获取<label v-if="countTimer > 0">({{ countTimer }}s)</label></span>
        </el-button>
      </el-popover>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" auto-width :clstag="`pageclick|keycount|${pageClstag}|${otherClstag}unbind_sure`" @click="unbind">确定</el-button>
      <el-button plain size="small" auto-width :clstag="`pageclick|keycount|${pageClstag}|${otherClstag}unbind_cancel`" @click="close(false)">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  assetRemove,
} from '@/api/apis/property';
import {
  tenantOperatorPhone,
  tenantOperatorSendVerify,
} from '@/api/apis/common';

let time = 0;
export default {
  name: 'UnbindShop',
  props: {
    businessType: {
      type: String,
      default: '200', // 默认为 pop，'110' - 全渠道, '200' - pop, '300' - VC
    },
    visible: Boolean,
    // 已选导入供应商信息
    currentSelect: {
      type: Object,
      default: () => ({}),
    },
    pageClstag: String, // 页面路径埋点
    otherClstag: String, // evenid额外前缀
  },
  data() {
    return {
      phone: '', // 手机号
      code: null, // 验证码
      loading: false,
      sendMsgCount: 0, // 发送验证码次数
      countTimer: 0, // 验证码计时器
      surePhoneTip: false, // 首次手机号确认
    };
  },
  computed: {
    dialogTitle() {
      switch (this.businessType) {
        case '300':
          return '解绑供应商';
        case '200':
        default:
          return '解绑店铺';
      }
    },
    // 验证码默认文案
    codePlaceholder() {
      if (this.phone && this.sendMsgDisable) {
        return `已向 ${this.phone} 发送验证码，请注意查收`;
      }
      return '请输入';
    },
    // 发送验证码
    sendMsgDisable() {
      return !(this.countTimer <= 0);
    },
  },
  watch: {
    // 定时器清空
    countTimer() {
      if (this.countTimer <= 0) {
        clearInterval(time);
      }
    },
  },
  created() {
    this.getPhone();
  },
  destroyed() {
    clearInterval(time);
  },
  methods: {
    // 解绑供应商
    async unbind() {
      if (!this.code) {
        this.$message({
          message: '请先输入验证码',
          type: 'warning',
        });
        return;
      }

      const params = {
        assetId: this.currentSelect.assetId,
        verifyCode: this.code,
      };
      const res = await assetRemove(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.$message({
          message: '解绑成功！',
          type: 'success',
          onClose: () => {
            this.$emit('closeSure', true);
          },
        });
      } else {
        this.$message.error(message || '解绑失败请稍后重试！');
      }
    },
    // 获取主账号手机号
    async getPhone() {
      const res = await tenantOperatorPhone();
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = false;
      if (code === 200) {
        this.phone = data.phone;
        this.loading = false;
      } else {
        this.$message.error(message || '获取当前账号手机号失败！');
      }
    },
    // 发送验证码到手机号
    async sendMsgCode() {
      if (!this.phone) {
        this.$message({
          message: '当前账号手机号不存在，请先进行添加！',
          type: 'warning',
        });
        return;
      }

      this.surePhoneTip = false;
      this.sendMsgCount++;
      this.loading = true;
      const params = {
        bizType: 6,
      };
      const res = await tenantOperatorSendVerify(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;

      this.loading = false;
      if (code === 200) {
        // 获取验证码倒计时
        this.countTimer = 120;
        time = setInterval(() => {
          this.countTimer--;
        }, 1000);
      } else {
        this.$message.error(message || '发送验证码失败！请稍后重试！');
      }
    },
    // 关闭绑定
    close(update = false) {
      this.$emit('closeSure', update);
    },
    // 去添加手机号
    goAddPhone() {
      window.open('https://aq.jd.com/process/modifyMobile?s=1');
    },
  },
};
</script>

<style lang="scss" scoped>
.unbind-shop-box {
  .info-box {
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 17px;
    &.mb15 {
      margin-bottom: 15px;
    }
  }
  .search-from {
    display: flex;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 30px;
    flex-wrap: wrap;
    .w180 {
      width: 180px;
    }
    .send-code-btn {
      margin-left: 10px;
      min-width: 112px;
    }
  }
}
</style>
<style lang="scss">
.unbind-shop-box .el-dialog{
  // min-width: 400px;
  overflow-y: scroll;
  .el-dialog__body {
    // margin-top: 20px;
  }
}
</style>
